<div class="modal-content">
    <div class="modal-body p-5">
        <div class="row">
            <div class="col-12">
                <button class="close" type="button" (click)="close()"><i class="fa fa-times"></i></button>
            </div>
            <div class="col-12">
                <h4><strong>{{confirmData.title || 'Confirm'}}</strong></h4>
            </div>

            <div class="col-12 d-flex align-items-center mt-5">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Filtrar Accesos</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>
            </div>
            
            <div class="col-12 max-height mt-5">

                <table mat-table [dataSource]="tabla">
                    <ng-container matColumnDef="value">
                        <td mat-cell *matCellDef="let element" class="d-flex align-items-center border-0">
                            <mat-icon matListItemIcon class="mr-3">play_arrow</mat-icon> <span>{{element.value}}</span>
                        </td>
                    </ng-container>
                    
                    <tr
                        mat-row
                        *matRowDef="let row; columns: ['value'];"
                    ></tr>
                </table>
            </div>
        </div>

    </div>
</div>